import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ Dark por defecto (si el usuario guardó tema, se respeta)
const savedTheme = localStorage.getItem('theme'); // 'dark' | 'light' | null
const shouldUseDark = savedTheme ? savedTheme === 'dark' : true;
document.documentElement.classList.toggle('dark', shouldUseDark);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();